




















import { Component, Vue } from 'vue-property-decorator'
import { contentWebservice } from '../webservices/content.webservice'
import { ContentModel } from '@/models/Content.model'
import VueMarkdown from 'vue-markdown'

@Component({
    components: {
        VueMarkdown,
    },
})
export default class Vision extends Vue {
    private content: ContentModel = {} as ContentModel

    async mounted() {
        this.content = await contentWebservice.getContent()
    }
}
